import React from 'react';
import { Header, Responsive, Segment, Tab } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import EmployeeInfo from './Employee/EmployeeInfo';
import Workload from './Workload/Workload';
import Employment from './Employee/Employment';
import EmployeeContractInfo from './Employee/EmployeeContractInfo';
import AcademicTitles from './Employee/AcademicTitles';
import PioMio from './Employee/PioMio';

export default class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const panes = [
            {
                menuItem: 'Lični podaci',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <EmployeeInfo />

                </Tab.Pane>)
            },
            localStorage.getItem('academicStaff') === 'true' && {
                menuItem: 'Izbori u zvanje',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <AcademicTitles />
                </Tab.Pane>)
            },
            (localStorage.getItem('main') === 'true' || localStorage.getItem('associate') === 'true' || localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') && {
                menuItem: 'Ugovori',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <EmployeeContractInfo />
                </Tab.Pane>)
            },
            (localStorage.getItem('osoblje') !== 'angažovano' && (localStorage.getItem('main') === 'true' || localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:')) && {
                menuItem: 'PIO/MIO',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <PioMio />
                </Tab.Pane>)
            },
            {
                menuItem: 'Angažmani',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <Employment />
                </Tab.Pane>)
            },
            // (JSON.parse(localStorage.getItem('employee')).employeeType._key === 'nastavno osoblje' ||
            localStorage.getItem('academicStaff') === 'true' && {
                menuItem: 'Opterećenje',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <Workload />
                </Tab.Pane>)
            }


        ];
        return (

            <div>
                <Header as="h1"> Informacije o zaposleniku
                </Header>

                <Segment.Group raised >
                    <Segment>
                        <Header as="h3">{JSON.parse(localStorage.getItem('person')).firstName} {JSON.parse(localStorage.getItem('person')).lastName}
                            <Header.Subheader>
                                Ime i prezime
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment><Tab menu={{ color: 'blue', secondary: true, pointing: true }} panes={panes} /></Segment>


                    <ToastContainer hideProgressBar />
                </Segment.Group>


            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/HR/profile/Profile.js